import styled from 'styled-components';
import { StyledRow } from '../../components/shared/sharedStyles.styles';
import HeaderButton from '../../components/Header/ButtonsHeader/DefaultButton';

export const RequestsToolbarFiltersGrow = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
`;

export const RequestsToolbarRow = styled(StyledRow)`
  flex-wrap: wrap;
  align-items: center !important;
  margin: 0 0 20px 0 !important;
  min-height: auto !important;
  gap: 12px;
  width: 100%;

  @media (max-width: 800px) {
    margin-bottom: 12px !important;
    position: relative;
    min-height: 44px;
    padding: 8px 12px 0;
    justify-content: flex-start !important;
    align-items: center !important;
  }
`;

export const RequestsToolbarActions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  button {
    margin-bottom: 0 !important;
  }
`;

export const RequestsTableCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(21, 43, 78, 0.1);
  border: 1px solid rgba(21, 43, 78, 0.08);
  overflow: hidden;

  table thead tr,
  thead tr {
    background: linear-gradient(180deg, #eef1f6 0%, #e4e9f0 100%);
  }

  table thead th,
  thead th {
    border-bottom: 1px solid rgba(21, 43, 78, 0.12) !important;
    color: #152b4e !important;
    font-weight: 600 !important;
    font-size: 0.8rem !important;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  tbody tr {
    transition: background-color 0.15s ease;
  }
`;

export const RequestsTableCardFooter = styled.div`
  padding: 12px 16px 16px;
  border-top: 1px solid rgba(21, 43, 78, 0.07);
  background: linear-gradient(180deg, #f8fafc 0%, #fff 40%);
`;

/** Locações no mobile: filtro + Nova Locação empilhados acima da lista. */
export const RequestsMobileLocacoesStack = styled.div`
  width: 100%;
  padding: 0 12px;
  margin-bottom: 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RequestsMobileNovaLocacaoWrap = styled.div`
  position: relative;
  width: 100%;
`;

export const RequestsMobileNovaLocacaoButton = styled(HeaderButton)`
  width: 100% !important;
  min-height: 44px;
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;
